// extracted by mini-css-extract-plugin
module.exports = {"leaveBtn":"leaveBtn___HRpTt","icon":"icon___3B0FV","red":"red___LAJEQ","text":"text___2FOqS"};